import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function BrandHandMarkTwoLinesVariant3(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="131"
            height="8"
            viewBox="0 0 131 8"
            fill="currentColor"
            {...props}
        >
            <path d="M109.44 1.56194H105.544L106.997 0.792864C90.3955 0.856293 73.7036 1.45094 57.1765 2.33895C50.269 2.71159 43.2267 3.1556 36.3342 3.6551C24.0775 4.55104 11.9556 5.71654 0.0585484 7.4767C-0.181191 6.76312 0.343238 7.04063 1.12239 6.89791C18.069 3.75024 42.4625 2.48959 60.5778 1.56194C73.284 0.911794 88.8072 0.0396432 101.394 0C102.517 0 111.373 0.35679 109.425 1.56194H109.44Z" />
            <path d="M130.837 3.88504C131.736 4.35283 128.679 5.15362 127.675 5.18533C123.884 5.31219 116.587 4.24975 112.152 4.13082C99.5505 3.78196 84.4619 4.87612 71.8606 5.72449C62.4958 6.35085 53.1459 7.19921 43.841 8C44.1407 6.94549 48.6658 6.91378 50.4638 6.75521C69.2384 5.08227 94.8157 3.06839 113.605 3.62339C117.456 3.73439 124.513 4.76512 127.66 4.65411C128.724 4.61447 130.417 3.6789 130.837 3.89297V3.88504Z" />
        </svg>
    );
}
